var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-process"},[_c('test-question-list',{attrs:{"current-key":_vm.key}}),_c('test-menu',{model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }